import React, { useMemo } from "react";
import { FaMountainSun } from "react-icons/fa6";
import { GiGreekTemple } from "react-icons/gi";
import { GiBookCover } from "react-icons/gi";
import { ImSpoonKnife } from "react-icons/im";
import { FaGamepad } from "react-icons/fa";
import { MdFamilyRestroom } from "react-icons/md";
import { TbClock24 } from "react-icons/tb";
import { FaHistory } from "react-icons/fa";
import { FaHiking } from "react-icons/fa";
import { IoIosPin } from "react-icons/io";
import { FaTree } from "react-icons/fa6";
import { FaGlassMartiniAlt } from "react-icons/fa";
import { FaCamera } from "react-icons/fa";
import { HiShoppingCart } from "react-icons/hi";
import { MdOutlineWaves } from "react-icons/md";
import { FaHandshakeAngle } from "react-icons/fa6";
import { MdSportsSoccer } from "react-icons/md";
import { FaTrainTram } from "react-icons/fa6";
import { MdHealthAndSafety } from "react-icons/md";
import { Typography, Flex, Tag } from "antd";
const COLOR = [
  "#0399b4",
  "#bf49c6",
  "#b43726",
  "#4c96e2",
  "#a702c5",
  "#6d131b",
  "#5790e3",
  "#3f2003",
  "#9320c4",
  "#c2388f",
  "#f811ff",
  "#2e12a6",
  "#36adb0",
  "#20a316",
];

const CategoryPill = ({ category, index }) => {
  const { Title, Paragraph, Text } = Typography;

  const randomColor = useMemo(() => {
    const randomSeed = Math.random();

    return COLOR[
      (Math.floor(randomSeed * COLOR.length) + index) % COLOR.length
    ];
  }, []);

  const categoryIcons = {
    Adventure: <FaMountainSun />,
    Architecture: <GiGreekTemple />,
    "Art and Culture": <GiBookCover />,
    Culinary: <ImSpoonKnife />,
    Entertainment: <FaGamepad />,
    Family: <MdFamilyRestroom />,
    "Full Day Tour": <TbClock24 />,
    Historical: <FaHistory />,
    "Hiking and Walking": <FaHiking />,
    "Must Visit Sites": <IoIosPin />,
    "Nature and Wildlife": <FaTree />,
    Nightlife: <FaGlassMartiniAlt />,
    Photography: <FaCamera />,
    Shopping: <HiShoppingCart />,
    Sightseeing: <MdOutlineWaves />,
    "Social Impact": <FaHandshakeAngle />,
    Sport: <MdSportsSoccer />,
    "Transportation activities": <FaTrainTram />,
    Wellness: <MdHealthAndSafety />,
    Cultural: <GiBookCover />,
  };
  const restrictionsStyle = {
    // padding: "2px 10px",
    border: "1px solid",
    borderRadius: 20,
  };
  const restrictionStyle = {
    ...restrictionsStyle,
    color: randomColor,
    borderColor: randomColor,
    backgroundColor: "#FEFEFE",
    padding: "5px 15px 5px 15px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  };
  // const randomColor =
  // COLOR[
  //   (Math.floor(randomSeed * COLOR.length) + index) % COLOR.length
  // ];

  return (
    <Flex justify="center" align="center" style={restrictionStyle}>
      {/* Icon container */}
      <Flex
        justify="center"
        align="center"
        style={{
          color: randomColor,
          borderColor: randomColor,
          backgroundColor: "#FEFEFE",
          marginTop: "2px",
          fontSize: "16px",
        }}
      >
        {categoryIcons[category] && <span>{categoryIcons[category]}</span>}
      </Flex>

      {/* Text container */}
      <Flex
        justify="center"
        align="center"
        style={{
          color: randomColor,
          borderColor: randomColor,
          backgroundColor: "#FEFEFE",
          marginLeft: "5px",
          fontWeight: "700",
          marginTop: "-2px",
          fontSize: "16px",
        }}
      >
        {category}
      </Flex>
    </Flex>
  );
  // if(categoryIcons[category]){
  //   return (
  //     <Tag
  //       icon={<span style={{marginBottom: "-3px"}}>{categoryIcons[category]}</span>}
  //       color="#55acee"
  //     >
  //       Twitter
  //     </Tag>
  //   );
  // }
};

export default CategoryPill;
